import React from 'react';
import { Link } from 'react-router-dom';
import { listingTypes } from '../data/listings';

const Footer = () => {
    const allProvinces = [
        "Buenos Aires", "CABA", "Córdoba", "Santa Fe", "Mendoza",
        "Tucumán", "Salta", "Misiones"
    ];

    return (
        <footer className="bg-gray-900 text-gray-300 mt-24 pt-20 pb-10">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
                    <div className="space-y-6">
                        <div className="flex items-center">
                            <img src="/EA-logo-esteticas.png" alt="Logo" className="w-10 h-10 mr-3" />
                            <span className="text-xl font-bold text-white tracking-tight">Estéticas <span className="text-rose-500">AR</span></span>
                        </div>
                        <p className="text-sm leading-relaxed opacity-80">
                            El ecosistema definitivo para el cuidado personal en Argentina. Conectamos a los mejores profesionales con quienes buscan excelencia en belleza y bienestar.
                        </p>
                        <div className="flex space-x-4">
                            {/* Instagram */}
                            <a href="#" className="w-9 h-9 rounded-xl bg-white/5 flex items-center justify-center hover:bg-rose-500 hover:text-white transition-all duration-300 group">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </a>
                            {/* TikTok */}
                            <a href="#" className="w-9 h-9 rounded-xl bg-white/5 flex items-center justify-center hover:bg-rose-500 hover:text-white transition-all duration-300 group">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .8.11V9.42a7.27 7.27 0 0 0-1-.07A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                                </svg>
                            </a>
                            {/* Facebook */}
                            <a href="#" className="w-9 h-9 rounded-xl bg-white/5 flex items-center justify-center hover:bg-rose-500 hover:text-white transition-all duration-300 group">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">Categorías</h4>
                        <ul className="space-y-4 text-sm">
                            {Object.entries(listingTypes).map(([key, value]) => (
                                <li key={key}>
                                    <Link to={`/categoria/${key}`} className="hover:text-rose-400 transition-colors inline-block">
                                        {value}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">Provincias</h4>
                        <ul className="grid grid-cols-2 gap-4 text-sm">
                            {allProvinces.map(province => (
                                <li key={province}>
                                    <Link to={`/provincia/${province.toLowerCase().replace(/ /g, '-')}`} className="hover:text-rose-400 transition-colors">
                                        {province}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">Newsletter</h4>
                        <p className="text-sm mb-4 opacity-80">Recibí beneficios exclusivos y tendencias cada semana.</p>
                        <div className="flex">
                            <input
                                type="email"
                                placeholder="Tu email"
                                className="bg-white/5 border border-white/10 rounded-l-lg px-4 py-2 w-full focus:outline-none focus:border-rose-500 transition-colors text-sm"
                            />
                            <button className="bg-rose-600 hover:bg-rose-700 text-white px-4 py-2 rounded-r-lg transition-colors">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="border-t border-white/10 pt-8 flex flex-col md:row items-center justify-between text-xs opacity-60">
                    <p>&copy; 2026 The Curator Group. Todos los derechos reservados.</p>
                    <div className="flex space-x-6 mt-4 md:mt-0">
                        <span className="hover:text-white cursor-pointer transition-colors">Política de Privacidad</span>
                        <span className="hover:text-white cursor-pointer transition-colors">Términos y Condiciones</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
